<template>
  <div id="app">
    <div v-show="!isAppReady" class="preloader">
      <lottie-player :src="require('@/assets/lottie/Preloader.json')" class="ticker-animation" background="transparent"
        speed="1" style="width: 150px; height: 150px;" loop autoplay>
      </lottie-player>
    </div>

    <transition name="fade">
      <div v-if="isAppReady">
        <Navbar />
        <router-view />
        <Footer />
      </div>
    </transition>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Footer from '@/components/Footer.vue'


export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
      isAppReady: false,
    };
  },
  mounted() {
    setTimeout(() => {
      if (document.readyState === 'complete') {
        this.isAppReady = true;
      } else {
        window.addEventListener('load', () => {
          this.isAppReady = true;
        });
      }
    }, 3000);
  },
}
</script>

<style>
body {
  margin: 0;
  background: #111;
  font-family: 'Sora', sans-serif;
}

/* Scrollbar track background */
::-webkit-scrollbar {
  width: 6px;
  /* Slim width */
  background: #101010;
  /* Match dark theme background */
}

/* Scrollbar thumb (the draggable part) */
::-webkit-scrollbar-thumb {
  background-color: #444;
  /* Slightly lighter for visibility */
  border-radius: 10px;
}

/* On hover */
::-webkit-scrollbar-thumb:hover {
  background-color: #666;
}

/* Optional: scrollbar corner (for both directions) */
::-webkit-scrollbar-corner {
  background: #101010;
}

.container {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 20px;
}

.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #121212;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.fade-enter-active {
  transition: opacity 1s ease;
}
.fade-enter-from {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}
@media (max-width: 767px) {
  .container {
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
    /* Use padding instead of fixed width/margin */
  }
}
</style>
